'use client';

// react
import { useEffect, useState } from 'react';
// @mui
import {
  Language as LanguageIcon,
  YouTube as YouTubeIcon,
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedinIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';
import { Typography, Box, Grid, BottomNavigationAction, Chip } from '@mui/material';
// enums
import { USER_GROUP_TYPE } from '@/enums';

const getDescriptionLabel = (userGroupType: USER_GROUP_TYPE) => {
  switch (userGroupType) {
    case USER_GROUP_TYPE.STARTUP:
      return 'About';
    case USER_GROUP_TYPE.SME:
    case USER_GROUP_TYPE.INSTITUTION:
    case USER_GROUP_TYPE.INCUBATOR:
      return 'How we work?';
    case USER_GROUP_TYPE.INVESTOR:
      return 'How we invest?';
  }
};

type Props = {
  title: string;
  interests: any[];
  categories: any[];
  userGroupType: USER_GROUP_TYPE;
  description: string;
  social: any;
};

export default function StoryDrivenUserGroup({
  title,
  interests,
  categories,
  userGroupType,
  description,
  social,
}: Props) {
  const [userGroupDescription, setUserGroupDescription] = useState<
    string | null | JSX.Element | JSX.Element[]
  >(null);
  useEffect(() => {
    if (!userGroupDescription && description) {
      import('html-react-parser').then((res) => {
        setUserGroupDescription(res.default(description ?? ' '));
      });
    }
  }, [description, userGroupDescription]);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Grid container sx={{ display: 'flex', justifyContent: 'center' }} spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: '22px',
                textAlign: 'center',
              }}
            >
              {title}
            </Typography>
          </Box>
        </Grid>
        {Boolean(categories?.length) && (
          <>
            <Grid item xs={12}>
              <Box sx={{ mt: 5 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '18px', p: 1 }}>
                  Our Service Categories
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                {categories?.map((category, index) => {
                  return (
                    category?.title && (
                      <Chip
                        color="warning"
                        variant="filled"
                        sx={{ m: 1, color: 'white' }}
                        key={`sme-category-${category.id}-${index}`}
                        label={category?.title}
                      />
                    )
                  );
                })}
              </Box>
            </Grid>
          </>
        )}
        {Boolean(interests?.length) && (
          <>
            <Grid item xs={12}>
              <Box sx={{ mt: 5 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '18px', p: 1 }}>
                  Industry Interests
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                {interests?.map((interest, index) => {
                  return (
                    interest?.title && (
                      <Chip
                        sx={{ m: 1 }}
                        key={`industry-interest-${interest.id}-${index}`}
                        variant="outlined"
                        label={interest?.title}
                      />
                    )
                  );
                })}
              </Box>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Box sx={{ mt: 5 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '18px', p: 1 }}>
              {getDescriptionLabel(userGroupType)}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <div className="eventPostAbout ql-editor">{userGroupDescription}</div>
          </Box>
        </Grid>
      </Grid>

      <Box className="startupdashboardiconbox" sx={{ marginTop: 2, textAlign: 'center' }}>
        <>
          {social && (
            <>
              {social?.personalWebSite && (
                <a target="_blank" rel="noreferrer" href={social?.personalWebSite}>
                  <BottomNavigationAction icon={<LanguageIcon />} />
                </a>
              )}
              {social.facebook && (
                <a target="_blank" rel="noreferrer" href={social?.facebook}>
                  <BottomNavigationAction icon={<FacebookIcon />} />
                </a>
              )}
              {social.twitter && (
                <a target="_blank" rel="noreferrer" href={social?.twitter}>
                  <BottomNavigationAction icon={<TwitterIcon />} />
                </a>
              )}
              {social.linkedin && (
                <a target="_blank" rel="noreferrer" href={social?.linkedin}>
                  <BottomNavigationAction icon={<LinkedinIcon />} />
                </a>
              )}
              {social.youtube && (
                <a target="_blank" rel="noreferrer" href={social?.youtube}>
                  <BottomNavigationAction icon={<YouTubeIcon />} />
                </a>
              )}
              {social.instagram && (
                <a target="_blank" rel="noreferrer" href={social?.instagram}>
                  <BottomNavigationAction icon={<InstagramIcon />} />
                </a>
              )}
            </>
          )}
        </>
      </Box>
    </Box>
  );
}
